import _color from '@/assets/utils/color.js';
<template>
  <div
    class="mx-auto w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl ..."
  >
    <vx-card title="Error Items">
      <ul>
        <li v-for="(err, index) in errdata" :key="index">{{ err }}</li>
      </ul>
      <br />
      <div class="pt-4">
        <vs-button @click="onverify" color="warning">ดึงรายการจาก HouseBL</vs-button>
      </div>
    </vx-card>
  </div>
</template>

<script>
import axios from "../axios_app";

export default {
  data() {
    return {
      skus_code: "",
    };
  },
  components: {},
  props: ["errdata","declaration","depdate","filename"],
  methods: {
    clsd: function () {
      this.skus_code = "";
    },
    onverify() {
      // console.log(this.declaration);
      // console.log(this.depdate);
      // console.log(this.filename);
      let vm = this;
      // console.log(this.declaration);
      if (this.declaration == "" || this.depdate == "") {
        vm.$vs.notify({
          title: "Upload",
          text: "Please Enter Declaration Number",
          color: "danger",
          position: "top-right",
          time: 3000,
        });
      } else {
        this.progress = true;
        let formData = {
          filename: this.filename,
          declaration: this.declaration,
          depdate: this.depdate,
          token: localStorage.getItem("token"),
          dbname: localStorage.getItem("dbname"),
          comgroups_id: localStorage.getItem("comgroups_id"),
        };

        axios
          .post("/ApiExbUpVerifyNotMatch", formData)
          .then((res) => {
            // console.log(res.data.message);
            if (res.data.status == "false") {
              vm.$vs.notify({
                title: "Upload",
                text: res.data.message,
                color: "danger",
                position: "top-right",
                fixed: true,
              });
            } else if (res.data.status == "error") {
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Outbound Error",
                text: res.data.message,
                fixed: true,
              });

              let stdata = res.data.errdata;
              let tdata = stdata.split(",");

              // this.errdata = res.data.errdata;
              // this.errdata = tdata.length;
              this.errdata = tdata;
              setTimeout(() => {
                this.errorshow = true;
              }, 300);
            } else {
              vm.$vs.notify({
                title: "Upload",
                text: res.data.message,
                color: "success",
                position: "top-right",
                time: 3000,
              });
              vm.$emit("done");
            }
          })
          .catch((err) => {
            // console.log(err);
            vm.$vs.notify({
              title: "Upload",
              text: err,
              color: "danger",
              position: "top-right",
              fixed: true,
            });
          });
      }
    },
  },
  beforeCreate() {},
  created() {
    // console.log(this.$router.currentRoute);
  },
};
</script>

<style scoped>
li {
  color: red;
}
</style>
